import { Pagination } from '@components/Pages/AnswersPage/constants';
import { UnitEntityInterface, UnitQueryInterface } from '@types';

export type UnitState = {
  units: UnitEntityInterface[];
  total: number;
  unitsFilters: UnitQueryInterface;
};

export const initialUnitsFilters: UnitQueryInterface = {
  offset: 0,
  limit: Pagination.UNITS_ON_ADMIN_PAGE_COUNT_FIRST,
  withRoles: true,
};

export const unitInitialState: UnitState = {
  units: [],
  total: 0,
  unitsFilters: initialUnitsFilters,
};
